module.exports = __webpack_public_path__ + "img/introduction.9f6ec67b.png";